/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

(function() {
    let touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      let moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});

  // setTimeout(function() {
  // var return_on = document.querySelector('.returnprime input');
  // if(return_on != null) {
  // return_on.addEventListener('focus', ()=>{
  //   if(return_on.value == "") {
  //   	return_on.value = "MG";
  //   }
  // });
  // return_on.addEventListener('blur', ()=>{
  //   if(return_on.value == "MG") {
  //   	return_on.value = "";
  //   }
  // });
  // }
  // },1000);
/*  
  
  if(document.querySelector("body").classList.contains("pagetype-index") && !getCookie("splashscreen")) {
     document.cookie = "splashscreen=1"; 
  if(window.innerWidth < 768) {
     document.getElementById('splashscreen').style.backgroundImage = "url('//cdn.shopify.com/s/files/1/2869/2938/t/24/assets/splash_portrait_3.jpg?v=95972653854056135631683820416')"; 
     document.getElementById('splashvideo_p').style.visibility = 'visible';
     document.getElementById('splashvideo').style.visibility = 'hidden';
  } else {
     document.getElementById('splashscreen').style.backgroundImage = "url('//cdn.shopify.com/s/files/1/2869/2938/t/24/assets/splash_1.jpg?v=172238335275280341351683820416')";
     document.getElementById('splashvideo').style.visibility = 'visible';
	 document.getElementById('splashvideo_p').style.visibility = 'hidden';
  }
//  	 document.getElementById('splashscreen').style.backgroundSize = "cover";
    document.getElementById('splashscreen').style.zIndex = "100000";
//  document.getElementById('splashscreen').style.backgroundPosition = "center";
	 document.getElementById('splashscreen').style.visibility = 'visible';
  	 document.getElementById('splashscreen').style.opacity = 1;
    
      document.getElementById('splashscreen').addEventListener('click',function(e) {
         document.getElementById('splashscreen').style.visibility = 'hidden';
         document.getElementById('splashscreen').style.opacity = 0;
        document.getElementById('splashscreen').style.zIndex = "auto";
        document.getElementById('splashscreen').style.display = "none";
     document.getElementById('splashvideo').style.display = "none";
	 document.getElementById('splashvideo_p').style.display = "none";
      });

  
      setTimeout(function() {
         document.getElementById('splashscreen').style.visibility = 'hidden';
         document.getElementById('splashscreen').style.opacity = 0;
        document.getElementById('splashscreen').style.zIndex = "auto";
        document.getElementById('splashscreen').style.display = "none";
     document.getElementById('splashvideo').style.display = "none";
	 document.getElementById('splashvideo_p').style.display = "none";
      },7000);
  }

*/

 function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
/*  
  var el = document.querySelector('.dropdown-el');

el.onclick = function(e) {
  e.preventDefault();
  e.stopPropagation();
  el.classList.toggle('expanded');
  document.getElementById(e.target.getAttribute('for')).checked=true;
  document.getElementById('CurrencySelector__Select').value = document.getElementById(e.target.getAttribute('for')).value;
  document.getElementById('CurrencySelector__Select').dispatchEvent(new Event('change'));
}

setTimeout(function(){
	document.getElementById("sort-"+document.getElementById('CurrencySelector__Select').value).checked=true;
},500);
*/
  })();

const elements = document.querySelectorAll('.matildagoad-accordion');

elements.forEach(element => {
  let btn = element.querySelector('h3');

  btn.addEventListener('click', ()=>{
  	element.classList.toggle('matildagoad-accordion-hide');
  });
});

const homepagevideo = document.querySelectorAll('.homepageblocks .videowrapper video');
function checksize() {
homepagevideo.forEach(element => {
  let lastimage = element.parentNode.parentNode.parentNode.parentNode.parentNode.querySelector('.slide img');
  /* window.console.log(element.parentNode.parentNode.parentNode.parentNode.parentNode,lastimage,lastimage.offsetHeight); */
  if(lastimage.offsetHeight > 0) {
  	element.style.height = lastimage.offsetHeight + "px";
  } else {
    setTimeout(checksize,500);
  }
});
}
checksize();

window.addEventListener("resize", checksize);

const homepagevideo2 = document.querySelectorAll('.Section-Homepage-Blocks2 .videowrapper video');
function checksize2() {
homepagevideo.forEach(element => {
  let lastimage = element.parentNode.parentNode.parentNode.parentNode.parentNode.querySelector('.slide img');
  /*window.console.log(element.parentNode.parentNode.parentNode.parentNode.parentNode,lastimage,lastimage.offsetHeight);*/
  if(lastimage.offsetHeight > 0) {
  	element.style.height = (lastimage.offsetHeight-2) + "px";
  } else {
    setTimeout(checksize2,500);
  }
});
}
checksize2();

window.addEventListener("resize", checksize2);



const interval = setInterval(() => {
  const formEmbed = document.querySelector('#app-embed');
  if (formEmbed && formEmbed.shadowRoot) {
    const style = document.createElement('style');
    style.textContent = `
    	._inline_stahb_47 ._formContainer_stahb_30 {
    		max-width: 600px !important;
    	}
    	form._formFieldset_8skcf_76 {
    		display: grid !important;
    		grid-template-columns: repeat(2, 1fr);
    		align-items: flex-end;
    	}
    	button._formSubmitButton_8skcf_90 {
    		grid-column: span 2 !important;
    		width: 100% !important;
    		margin-top: 32px !important;
    	}
    	* {
    		font-family: highway_gothic_narrowregular!important;
    	}
    	output {
    		font-family: mrs-eaves,serif !important;
    	}
    	--form-error-color {
    		color: #bc4348;
    	}
    `;
    formEmbed.shadowRoot.appendChild(style);
    clearInterval(interval);
  }
}, 100);
